import {
  DOCTORS_GET_LIST,
  DOCTORS_GET_LIST_ERROR,
  DOCTORS_GET_LIST_SUCCESS,
  DOCTOR_GET_DATA,
  DOCTOR_GET_DATA_SUCCESS,
  DOCTOR_GET_DATA_ERROR,
  DOCTOR_GET_AVATAR,
  DOCTOR_GET_AVATAR_SUCCESS,
  DOCTOR_GET_AVATAR_ERROR,
  DOCTOR_ADD_ITEM,
  DOCTOR_ADD_ITEM_SUCCESS,
  DOCTOR_ADD_ITEM_ERROR,
  DOCTOR_CLEAR_DATA,
} from "../actions";

//* GET LIST OF THE DOCTORS (ACCESS ADMINS) //--------------------------------------------------------
export const getDoctorsList = (payload) => {
  //console.log(payload);

  return {
    type: DOCTORS_GET_LIST,
    payload: payload,
  };
};

export const getDoctorsListSuccess = (items) => {
  // console.log(items);
  return { type: DOCTORS_GET_LIST_SUCCESS, payload: items };
};

export const getDoctorsListError = (error) => ({
  type: DOCTORS_GET_LIST_ERROR,
  payload: error,
});

//* GET DATA DOCTOR  -----------------------------------------------------------------------------
export const getDoctorData = (payload) => {
  console.log("inside Action", payload);

  return {
    type: DOCTOR_GET_DATA,
    payload: payload,
  };
};

export const getDoctorDataSuccess = (items) => {
  //console.log(items);
  return { type: DOCTOR_GET_DATA_SUCCESS, payload: items };
};

export const getDoctorDataError = (error) => ({
  type: DOCTOR_GET_DATA_ERROR,
  payload: error,
});

//* GET AVATAR DOCTOR  ---------------------------------------------------------------------------
export const getDoctorAvatar = (item) => {
  console.log("inside get avatar action");
  return {
    type: DOCTOR_GET_AVATAR,
    payload: item,
  };
};

export const getDoctorAvatarSuccess = (items) => {
  // console.log(items);

  return {
    type: DOCTOR_GET_AVATAR_SUCCESS,
    payload: items,
  };
};

export const getDoctorAvatarError = (error) => {
  // console.log(error);
  return {
    type: DOCTOR_GET_AVATAR_ERROR,
    payload: error,
  };
};

//* ADD DOCTOR (ACCESS SUPER ADMIN OR ADMIN)// ----------------------------------------------------------------------------------------------
export const addDoctorItem = (item) => ({
  type: DOCTOR_ADD_ITEM,
  payload: item,
});

export const addDoctorItemSuccess = (items) => {
  //console.log(items);

  return {
    type: DOCTOR_ADD_ITEM_SUCCESS,
    payload: items,
  };
};

export const addDoctorItemError = (error) => {
  //console.log(error);
  return {
    type: DOCTOR_ADD_ITEM_ERROR,
    payload: error,
  };
};

//* CLEAR DOCTOR DATA // ---------------------------------------------------------------------------------------------
// clearing redux state when unmounting doctor profile page
export const clearDoctorData = (history) => {
  console.log("clearDoctorData -> history", history);

  return {
    type: DOCTOR_CLEAR_DATA,
    payload: { history },
  };
};
